import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import client, { resolveImageUrl, gbp } from "@/lib/api";

// Homepage strip — IG/TikTok-style shoppable grid. Pulls the admin-curated
// `/api/shoppable-feed` list and falls back to top-12 active products. Each
// tile is a square, hover-animated, and links straight to PDP. Mobile shows
// a horizontal-scroll carousel; desktop renders a 6-wide grid.

export default function ShoppableFeedStrip() {
  const [data, setData] = useState(null);
  useEffect(() => { client.get("/shoppable-feed").then((r) => setData(r.data)).catch(() => setData({ items: [] })); }, []);

  if (!data || (data.items || []).length === 0) return null;

  return (
    <section className="border-b border-black/10 bg-white" data-testid="home-shoppable-feed">
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-16 lg:py-20">
        <div className="flex items-end justify-between gap-6 mb-8 flex-wrap">
          <div>
            <div className="label-eyebrow moto-accent">Shop the feed</div>
            <h2 className="font-display text-3xl md:text-5xl tracking-tighter mt-2 leading-[0.95]">{data.caption || "Tap to shop."}</h2>
          </div>
          <Link to="/shop-the-feed" className="label-eyebrow text-xs underline underline-offset-4 hover:text-[#FF3B30]" data-testid="shoppable-feed-see-all">
            See full feed →
          </Link>
        </div>
        <div className="grid grid-flow-col auto-cols-[42%] md:auto-cols-[18%] lg:grid-flow-row lg:grid-cols-6 gap-3 overflow-x-auto lg:overflow-visible snap-x snap-mandatory pb-2 -mx-6 px-6 lg:mx-0 lg:px-0 lg:pb-0">
          {(data.items || []).slice(0, 12).map((p) => (
            <Link
              to={`/product/${p.id}`}
              key={p.id}
              className="group block snap-start aspect-square overflow-hidden bg-[#FAFAFA] hairline relative"
              data-testid={`shoppable-tile-${p.id}`}
            >
              <img
                src={resolveImageUrl(p.image_url || (p.images || [])[0])}
                alt={p.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-[1.05] transition-transform duration-500"
              />
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-3 text-white opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="font-display text-base tracking-tight truncate leading-tight">{p.title}</div>
                <div className="label-eyebrow text-[10px] text-white/85 mt-0.5">{gbp(p.discount_price || p.price)}</div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
